import * as React from "react";
import TextInput from "../../../../Layout/Inputs/TextInput";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";

export function SupplierTransitTime({
  ltlPipeline,
}: {
  ltlPipeline: LtlPipelineViewModel;
}) {
  return (
    <TextInput
      label="Supplier Transit Time"
      disabled
      value={ltlPipeline?.SupplierTransitTime ?? ""}
    />
  );
}
